
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TableFilter extends Vue {
  @Prop(String)
  placeholder!: string;

  @Prop(String)
  store!: string;

  @Prop(Array)
  options!: any[];

  @Prop(String)
  field!: string;

  @Prop(String)
  optionPrefix!: string;

  @Prop(String)
  allLabel!: string;

  get filterValue(): string {
    return this.$store.state[this.store].filter;
  }

  filter(filter: string) {
    this.$store.dispatch(`${this.store}/filter`, filter);
  }
}
